import React from "react";
import Itens from "./_/container/Itens";
import "./style.scss";

const ListaDeInformacoes = props => <Itens {...props} />;

export default ListaDeInformacoes;